module.exports = __webpack_public_path__ + "img/auditFail.75d63948.png";